export * from './view-configuration.module'
export * from './view-configuration.service'